import Router from 'next/router'
import { useEffect, useState } from 'react'

export function useScrollRestoration() {
  const [scrollY, setScrollY] = useState(0)
  useEffect(() => {
    const handleRouteStart = () => setScrollY(window.scrollY)

    const handleRouteComplete = () => window.scrollTo(0, scrollY)

    Router.events.on('routeChangeStart', handleRouteStart)
    Router.events.on('routeChangeComplete', handleRouteComplete)
    return () => {
      Router.events.off('routeChangeStart', handleRouteStart)
      Router.events.off('routeChangeComplete', handleRouteComplete)
    }
  }, [scrollY])
}
